import CreditDashboard from '../homepage/views/CreditDashboard.vue';
import PastAdvisorCoreAnalyses from './views/PastAdvisorCoreAnalyses.vue';
const routes = [
  {
    name: 'credit-dashboard',
    path: '/advisor/creditdashboard',
    component: CreditDashboard,
  },
  {
    name: 'past-advisor-core-analyses',
    path: '/advisor/past-advisorcore-analyses',
    component: PastAdvisorCoreAnalyses,
  },
];

export default routes;
